export default "__VITE_ASSET__4a790074__"